import LocalizedStrings from 'react-localization'
import { commonEn, commonEs } from './common'
import { loginEn, loginEs } from './login'
import { profileEn, profileEs } from './profile'
import { usersEn, usersEs } from './users'
import { documentsEn, documentsEs } from './document'
import { findDuplicates } from 'tools/l10nTools'
import { invoicesEn, invoicesEs } from './invoices'
import { uploadEn, uploadEs } from './upload'
import { debtorsEn, debtorsEs } from './debtors'
import { documentEn, documentEs } from './documents'
import { reportsEn, reportsEs } from './reports'
import { dashboardEn, dashboardEs } from './dashboard'

const arrayOfFiles = [
  commonEn,
  loginEn,
  profileEn,
  usersEn,
  debtorsEn,
  documentsEn,
  invoicesEn,
  uploadEn,
  dashboardEn,
  dashboardEs,
]

let stringsObject = {
  en: {
    ...commonEn,
    ...loginEn,
    ...profileEn,
    ...usersEn,
    ...debtorsEn,
    ...documentsEn,
    ...invoicesEn,
    ...documentEn,
    ...uploadEn,
    ...reportsEn,
    ...dashboardEn,
  },
  es: {
    ...commonEs,
    ...loginEs,
    ...profileEs,
    ...usersEs,
    ...debtorsEs,
    ...documentsEs,
    ...invoicesEs,
    ...documentEs,
    ...uploadEs,
    ...reportsEs,
    ...dashboardEs,
  },
}

let strings = new LocalizedStrings(stringsObject)

if (process.env.NODE_ENV === 'development') findDuplicates(arrayOfFiles)

export default strings
